import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class RelatorioAlteracaoService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'relatorio-alteracoes';
    this.token = new Login();
  }

  previa(page: any = 1){
    return this.http.get<Object[]>(this.url + '/previa?page=' + page , {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  exclusaoItemPrevia(id: any){
    return this.http.delete<Object[]>(this.url + '/previa/exclusao-item/' + id, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
